module.exports = __webpack_public_path__ + "static/img/8.cc45db3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/8.png
// module id = 1c0V
// module chunks = 0